import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import translate from 'core/translate'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { QUIZ_CATALOG_CONFIG, QUIZ_CATALOG_TYPE, QuizSelectedItems } from './InstancesCatalogQuizQuestions-types'

const InstancesCatalogQuizQuestionsComponent = () => {
    const [selectedItems, setSelectedItems] = useState<QuizSelectedItems>([])

    return (
        <Content title={translate(QUIZ_CATALOG_TYPE)}>
            <Catalog
                type={QUIZ_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                treeView={QUIZ_CATALOG_CONFIG.treeView}
                additionalData={{}}
                fixedHeader={QUIZ_CATALOG_CONFIG.fixedHeader}
                isExistRightToolbar={QUIZ_CATALOG_CONFIG.isExistRightToolbar}
                hideHeader={QUIZ_CATALOG_CONFIG.hideHeader}
            />
        </Content>
    )
}

export const InstancesCatalogQuizQuestions = checkAvailableModule('instancesCatalog/quizQuestionsCatalog')
    ? InstancesCatalogQuizQuestionsComponent
    : null
